import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { putData } from '../Services/api'
import { toast } from 'react-toastify'

const Password = () => {
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.newPassword !== formData.confirmPassword) {
            toast.error("New passwords do not match");
            return;
        }

        try {
            setIsLoading(true);
            const res = await putData('/auth/change-password', {
                oldPassword: formData.oldPassword,
                newPassword: formData.newPassword
            });

            if (res.status) {
                toast.success(res.message);
                setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
            } else {
                toast.error(res.message);
            }
        } catch (error) {
            console.error("Error changing password:", error);
            toast.error("Something went wrong!");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/users/user-list">Users</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">
                                        Password Change
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Change Password</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <form onSubmit={handleSubmit}>
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group mb-3">
                                        <label className="form-label">Old Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="oldPassword"
                                            value={formData.oldPassword}
                                            onChange={handleChange}
                                            required
                                            placeholder='Old Password'
                                        />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label">New Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="newPassword"
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            required
                                            placeholder='New Password'
                                        />
                                    </div>
                                    <div className="form-group mb-3">
                                        <label className="form-label">Confirm Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            required
                                            placeholder='Confirm Password'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-end btn-page">
                                <Link to="/" className="btn btn-outline-secondary">Cancel</Link>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Updating...' : 'Change Password'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Password
